/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { logger as log } from '@common/logger';
import { PayoutPageService } from '@pages/PayoutPage/services';

const getSrv = () => {
  return vappContainer.get<PayoutPageService>(PayoutPageService.name);
};

export const addGroup = async (context: any, event: any) => {
  const currentState = 'ADD_GROUP';
  const method = 'addGroup';

  // @ts-ignore
  return new Promise(async (resolve, reject) => {
    try {
      log.log('context: ', context, 'event: ', event);
      const srv = getSrv();
      const shelves = await srv.agent.getAddGroupProps(event?.payload);
      if (shelves) {
        return resolve({
          key: 'ADD_GROUP_SUCCESS',
          value: {
            ...(shelves || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        log.error(`error in ${method}, msg: ${msg}`);
        return reject({
          key: 'ADD_GROUP_FAILED',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(`error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'ADD_GROUP_FAILED',
        value: err?.message,
      });
    }
  });
};
